import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (<Typewriter
    options={{
      strings: [
        "Data Analyst & Engineer",
        "Curious Learner",
        "Strategic Thinker",
        "Philosophical Problem Solver",
        "Aspiring Tech Explorer",
        "Business & Security Enthusiast",
        "CEO Mindset in Progress"
      ],
      autoStart: true,
      loop: true,
      deleteSpeed: 50,
    }}
  />
  );
}

export default Type;
